import { UISelectorType } from "../../../utilities/types";
import { AvatarCategory, AvatarSubCategory, AvatarCustomizationEntry } from "./types";

export const avatarCustomizeEntries: AvatarCustomizationEntry[] = [
    {
      id: 'avatarSnippetToChatOnClose',
      displayName: 'Close Button Behavior',
      category: AvatarCategory.Behavior,
      subCategory: AvatarSubCategory.Common,
      uiSelectorType: UISelectorType.dropDownSelector,
      containerName: "AvatarUI",
    },
    {
      id: 'avatar',
      displayName: 'Avatar',
      category: AvatarCategory.Appearance,
      subCategory: AvatarSubCategory.Avatar,
      uiSelectorType: UISelectorType.avatarSelector,
      containerName: "AvatarUI",
    },
    {
      id: 'avatarSwitchToChatButtonEnabled',
      displayName: 'Show switch to chat button',
      category: AvatarCategory.Header,
      subCategory: AvatarSubCategory.Controls,
      uiSelectorType: UISelectorType.booleanSelector,
      containerName: "AvatarUI",
    },
    {
      id: 'avatarSwitchToVoiceButtonEnabled',
      displayName: 'Show switch to voice button',
      category: AvatarCategory.Header,
      subCategory: AvatarSubCategory.Controls,
      uiSelectorType: UISelectorType.booleanSelector,
      containerName: "AvatarUI",
    },
    {
      id: 'avatarFullScreenMode',
      displayName: 'Enable Full Screen Mode',
      category: AvatarCategory.Header,
      subCategory: AvatarSubCategory.Controls,
      uiSelectorType: UISelectorType.booleanSelector,
      containerName: "AvatarUI",
    }
];
